module.exports = __webpack_public_path__ + "img/jinshukuai02.a8379a6f.jpg";